import { type FC } from "react";
import { generatePath, useParams } from "react-router-dom";

import { AbsoluteRoute, type RouteParams } from "../../../core/routes";
import { LinkStyled, linkColorClassName } from "../../../shared/styles";

import { CreateNewLensFolder, CreateNewOrganizationAndLensFolder } from "./messages.generated";

export interface CreateOrganizationOrLensFolderLinkProps {
    hasOrganizationsAvialableForLensFolderCreation: boolean;
    isDisabled?: boolean;
}
export const CreateOrganizationOrLensFolderLink: FC<CreateOrganizationOrLensFolderLinkProps> = ({
    hasOrganizationsAvialableForLensFolderCreation,
    isDisabled = false,
}) => {
    const { submissionId = "" } = useParams<RouteParams[AbsoluteRoute.SUBMIT_LENS_FOLDER_SELECT]>();
    const createLensFolderUrl = generatePath(AbsoluteRoute.SUBMIT_LENS_FOLDER_CREATE, { submissionId });
    const createOrganizationAndLensFolderUrl = generatePath(AbsoluteRoute.CREATE_ORG_LENS_FOLDER, {
        routeTo: "submit",
        submissionId,
    });

    if (isDisabled) {
        return null;
    }

    if (hasOrganizationsAvialableForLensFolderCreation) {
        return (
            <LinkStyled className={linkColorClassName} to={createLensFolderUrl}>
                <CreateNewLensFolder />
            </LinkStyled>
        );
    }

    return (
        <LinkStyled className={linkColorClassName} to={createOrganizationAndLensFolderUrl}>
            <CreateNewOrganizationAndLensFolder />
        </LinkStyled>
    );
};
